import registerForRails from 'js/utils/registerForRails';
import PublishingNavbar from 'js/journals/PublishingNavbar';
import JournalNavbar from 'js/journals/JournalNavbar';
import AdminBar from 'js/admin_bar/AdminBarActivator';
import StandaloneSearchContainer from 'js/journals/search/StandaloneSearchContainer';
import ArticlesFilters from 'js/journals/ArticlesFilters';
import ArticlesSort from 'js/journals/ArticlesSort';
import { trackCWV } from 'js/utils/trackCWV';
trackCWV();
import { loadRecordHit } from 'js/utils/loadRecordHit';
loadRecordHit();

registerForRails(
  {
    PublishingNavbar,
    JournalNavbar,
    AdminBar,
    StandaloneSearchContainer,
    ArticlesFilters,
    ArticlesSort,
  },
  [
    'js/journals/PublishingNavbar',
    'js/journals/JournalNavbar',
    'js/admin_bar/AdminBar',
    'js/journals/search/StandaloneSearchContainer',
    'js/journals/ArticlesFilters',
    'js/journals/ArticlesSort',
  ],
);
